// mui
import Container from '@mui/material/Container';
//
import { Helmet } from 'react-helmet-async';
// sections
import XacNhanMail from 'src/sections/xac-nhan-mail/xac-nhan-mail';

// ----------------------------------------------------------------------

export default function Page() {
  return (
    <>
      <Helmet>
        <title> Xác nhận đăng ký mượn ấn phẩm </title>
      </Helmet>

      <Container>
        <XacNhanMail />
      </Container>
    </>
  );
}
